/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHospitality = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9 2h6v2h-2v1.055A9 9 0 0 1 21 14v2h1v6H2v-6h1v-2a9 9 0 0 1 8-8.945V4H9V2zm3 5a7 7 0 0 0-7 7v2h14v-2a7 7 0 0 0-7-7zM4 18v2h16v-2H4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHospitality as Hospitality };
